import React from 'react';
import ItemConfig from "./ItemConfig";

function App() {
    return (
        <div className="App">
            <ItemConfig/>
        </div>
    );
}

export default App;
